import { MemberType } from '@lucidlink/dto/validation';
export class InvalidAccountTypeError extends Error {
    constructor() {
        super('Invalid account type');
    }
}
export function assertIsUser(account) {
    if (account.type !== MemberType.USER) {
        throw new InvalidAccountTypeError();
    }
    // NOTE: This is necessary, since to be valid UserAccountDetails it must contain crypto
    // Otherwise it could also be GuestUserAccountDetails
    const hasCryptoDetails = 'wrappingKey' in account &&
        'eAccountKey' in account &&
        'accountKeyGen' in account;
    if (!hasCryptoDetails) {
        throw new InvalidAccountTypeError();
    }
}
